// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Coding } from '@medplum/fhirtypes';
import { CLOUDPAT_HSAT_SERVICE_REQUEST_SYSTEM } from './system';

export const CLOUDPAT_HSAT_CODING: Coding = {
  system: CLOUDPAT_HSAT_SERVICE_REQUEST_SYSTEM,
  code: 'cloudpat-hsat',
  display: 'Home Sleep Apnea Test (HSAT) - WatchPAT',
};
